import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

import { NoActiveThreadState } from "../components/NoActiveThreadState";
import { usePrimaryEnvironmentId } from "../environments/primary";
import { useOpenHomeDraft } from "../hooks/useHomeDraft";
import { selectEnvironmentState, useStore } from "../store";

function ChatIndexRouteView() {
  const primaryEnvironmentId = usePrimaryEnvironmentId();
  // A draft needs somewhere to send to, so the home draft only opens once the
  // environment has finished bootstrapping and has at least one project.
  const canOpenHomeDraft = useStore((state) => {
    if (!primaryEnvironmentId) {
      return false;
    }
    const environmentState = selectEnvironmentState(state, primaryEnvironmentId);
    return environmentState.bootstrapComplete && environmentState.projectIds.length > 0;
  });
  const openHomeDraft = useOpenHomeDraft();

  useEffect(() => {
    if (!primaryEnvironmentId || !canOpenHomeDraft) {
      return;
    }
    void openHomeDraft(primaryEnvironmentId, { replace: true });
  }, [canOpenHomeDraft, openHomeDraft, primaryEnvironmentId]);

  return <NoActiveThreadState />;
}

export const Route = createFileRoute("/_chat/")({
  component: ChatIndexRouteView,
});
